import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";

import defaultTheme from "./defaultTheme";
import JsonPreviewEditor from "../styling/jsonPreviewEditor";

class ThemeEditor extends PureComponent {
	render() {
		return (
			<JsonPreviewEditor
				{...this.props}
				emptyValue={defaultTheme}
				previewPreferenceKey="theme"
				previewLabel="Preview Activity"
				previewNoun="this theme"
			/>
		);
	}
}

export default branch({
	activities: ["activities"],
	activitiesMap: ["activitiesMap"],
	selectedChecklistId: ["selectedChecklistId"],
	root: ["tree", "root"]
}, ThemeEditor);
